import { taskClient } from '../services/task-client';

export const createNewTask = async (data) => {
  const response = await taskClient().post(`${process.env.REACT_APP_TASKS_URL}`, data);
  return response.data;
}
